import { styled, Stack } from "@mui/material";

export const ProfileWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        padding: "var(--basic-padding)",
        backgroundColor: "var(--light-color)",
        borderRadius: "16px",
        overflow: "hidden",
        "& .profile-base-favicon-box": {
            overflow: "hidden",
            [theme.breakpoints.down(280)]: {
                "& svg": {
                    width: "100%",
                    height: "auto",
                }
            }
        },
        "& form": {
            display: "flex",
            flexDirection: "column",
            gap: "var(--flex-gap)",
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
        "& .client-avatar": {
            width: '132px',
            height: '132px',
            borderRadius: '50%',
            objectFit: 'cover'
        },
    }
})